export const isManualSmartCropEnabled = value =>
  value === true || String(value).toLowerCase() === "true"

export const appendImageModifiers = (url = "", modifiers = "") => {
  if (!url || !modifiers) return url
  return url.includes("?") ? `${url}&${modifiers}` : `${url}?${modifiers}`
}

const isValidManualSmartCropUrl = url =>
  Boolean(url) &&
  !String(url).startsWith("null:") &&
  !String(url).startsWith("undefined:")

const getImageServerAssetUrl = (imageServerUrl = "", assetID = "") =>
  isValidManualSmartCropUrl(imageServerUrl) &&
  isValidManualSmartCropUrl(assetID)
    ? `${imageServerUrl}${assetID}`
    : ""

export const getManualSmartCropBaseUrl = ({
  imageURLWithoutCrop = "",
  defaultImageURL = "",
  imageServerUrl = "",
  assetID = "",
  fileReference = "",
  imageResource = {},
} = {}) =>
  [
    imageURLWithoutCrop,
    defaultImageURL,
    getImageServerAssetUrl(imageServerUrl, assetID),
    imageResource?.imageURLWithoutCrop,
    imageResource?.defaultImageURL,
    getImageServerAssetUrl(
      imageResource?.imageServerUrl,
      imageResource?.assetID
    ),
    fileReference,
    imageResource?.fileReference,
  ].find(isValidManualSmartCropUrl) || ""

export const getManualSmartCropUrl = (item = {}, baseUrl = "") => {
  if (isValidManualSmartCropUrl(item?.imageURL)) return item.imageURL
  if (item?.cropRendition && baseUrl) return `${baseUrl}:${item.cropRendition}`
  return ""
}

const getBreakpointValue = deviceSize => {
  const match = String(deviceSize || "").match(/\d+(\.\d+)?/)
  return match ? Number(match[0]) : 0
}

export const getSortedManualSmartCropItems = (items = [], baseUrl = "") =>
  items
    .map((item, index) => ({
      item,
      index,
      imageURL: getManualSmartCropUrl(item, baseUrl),
      breakpoint: getBreakpointValue(item?.deviceSize),
    }))
    .filter(({ item, imageURL }) => item?.deviceSize && imageURL)
    .sort((a, b) => b.breakpoint - a.breakpoint || a.index - b.index)
    .map(({ item, imageURL }) => ({ ...item, imageURL }))

export const hasManualSmartCropItems = (items = [], baseUrl = "") =>
  getSortedManualSmartCropItems(items, baseUrl).length > 0

export const getManualSmartCropSrcSet = (url = "", { modifiers = "" } = {}) =>
  appendImageModifiers(url, modifiers)

export const getManualSmartCropFallbackUrl = ({
  defaultImageURL = "",
  defaultRendition = "",
  baseUrl = "",
  sortedItems = [],
} = {}) =>
  defaultImageURL ||
  (defaultRendition && baseUrl ? `${baseUrl}:${defaultRendition}` : "") ||
  baseUrl ||
  sortedItems[sortedItems.length - 1]?.imageURL ||
  ""
